import { GenericFilter } from "@repo/ui";
import type {
  FilterConfig,
  SelectOption,
  DataTableSetColumnFilter,
  DataTableFilters,
} from "@repo/ui";

type ListFilterKey = "name" | "customer" | "workflow";

type Props<T extends { [K in ListFilterKey]: T[K] }> = {
  setColumnFilter: DataTableSetColumnFilter<T>;
  filters: DataTableFilters<T>;
  listNameOptions: SelectOption<string>[];
  customerOptions: SelectOption<number>[];
  workflowOptions: SelectOption<number>[];
};

export const ListFilters = <T extends { [K in ListFilterKey]: T[K] }>({
  setColumnFilter,
  filters,
  listNameOptions,
  customerOptions,
  workflowOptions,
}: Props<T>) => {
  const filterConfigs: FilterConfig<T, ListFilterKey>[] = [
    {
      key: "name",
      title: "List Name",
      options: listNameOptions,
      className: "space-y-3",
    },
    {
      key: "customer",
      title: "Customer",
      options: customerOptions,
      columnKey: "id",
      className: "space-y-3 max-sm:my-4",
    },
    {
      key: "workflow",
      title: "Workflow Package",
      options: workflowOptions,
      columnKey: "id",
      className: "space-y-3 max-md:mt-4",
    },
  ];

  return (
    <GenericFilter<T, ListFilterKey>
      setColumnFilter={setColumnFilter}
      filters={filters}
      filterConfigs={filterConfigs}
      title="Filter Lists"
      minWidth="min-w-[600px]"
      gridCols="grid-cols-3"
    />
  );
};
